import { Component, Input, OnInit } from '@angular/core';
import { Technology } from 'src/app/shared/model/general/Technology';
import { IGenericMap } from 'src/app/shared/model/generic-map.interface';
import { ProjectFilter } from 'src/app/shared/model/ProjectFilter';
import { ProjectFilterService } from 'src/app/shared/services/project-list/project-filter.service';
import { IStateType } from './type-filtering-button/shared/models/state-type.interface';

@Component({
  selector: 'digires-project-overview-type-filtering',
  templateUrl: './project-overview-type-filtering.component.html',
  styleUrls: ['./project-overview-type-filtering.component.scss']
})
export class ProjectOverviewTypeFilteringComponent implements OnInit {
  technologyTypesArray: Technology[] = Object.values(Technology);
  technologyStateMap: IGenericMap<boolean[]> = {
    [Technology.WIND_ONSHORE]: [false],
    [Technology.STORAGE]: [false],
    [Technology.SOLAR]: [false],
  };

  constructor(private projectFilterService: ProjectFilterService) { }

  ngOnInit(): void {
    this.projectFilterService.observeProjectFilter().subscribe((data: ProjectFilter) => {
      this.technologyStateMap = {
        [Technology.WIND_ONSHORE]: [false],
        [Technology.STORAGE]: [false],
        [Technology.SOLAR]: [false],
      };

      if (!data.technology || !data.technology.length) {
        for (let key of Object.keys(this.technologyStateMap)) {
          this.technologyStateMap[key] = [true];
        }

        return;
      }

      for (let technology of data.technology) {
        this.technologyStateMap[technology] = [true];
      }
    });
  }

  toggleTechnologyFilter(stateType: IStateType) {
    stateType.state ?
      this.projectFilterService.filterForType(stateType.type) :
      this.projectFilterService.removeTechnologyFilter(stateType.type);
  }
}
